import React , { Component } from 'react';
import Menu from './menu';
import Footer from './footer';
import './App.css';
import {Container, Row, Col} from 'reactstrap';
import news1 from './img/news1.jpg';import news2 from './img/news2.jpg';
import news3 from './img/news3.jpg';import news4 from './img/news4.jpg';
import news9 from './img/news9.jpg';import news5 from './img/news5.jpg';
import news6 from './img/news6.jpg';import news7 from './img/news7.jpg';
import news8 from './img/news8.jpg';import news10 from './img/news10.jpeg';
import blog from './img/blog.jpg';import blogCont from './img/blog-cont.jpg';


export default class Berita extends Component {
  render() {
    return (
      <div>
      <Menu />
      <Container>
        <Row className="judul-blog">
          <Col xs="4">
            <img src={blog} style={{borderRadius:"50%"}}/>
          </Col>
          <Col xs="8" style={{paddingTop:"100px"}} align="right">
            <h1><b>NOT</b>JUST A BLOG</h1><br/>
            <div className="line-blog"/>
            <h4>the blog that we provide, is related<br/>to the development of IT today</h4>
          </Col>          
        </Row>
        <Row>
          <Col sm="8">
          <Blog/>
          </Col>        
          <Col sm="4">   {/*list blog/recent post */}
            <Row className="text-center">
              <Col sm="12">
                <h2>Terbaru Dari Kami</h2> <hr style={{width:"100%"}}/>                       
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news1} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Web, naik harga sebesar 15%!!</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news2} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Banyaknya Request Project WEB</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news3} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Ini dia daftar pekerjaan yang...</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news4} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Tertarik bekerja dengan kami ?</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news5} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Berusia 33 tahun? ini dia fakta unik 'super mario bros'</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news6} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Inovasi ATR untuk pilot dan penumpang</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news7} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Belum resmi, video gopro hero 7 muncul ditoko elektronik</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news8} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Xiaomi boyong tv mi 4A ke indonesia, bandrol rp 2 juta</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news9} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Pedagang Indonesia Juara di Instagram, Facebook dan WhatsApp Kedua se-Asia</a>                   
              </Col>
            </Row>
            <Row>
              <Col xs="5">
              <a href="#21"><img src={news10} className="berita img-thumbnail"/></a>
              </Col>
              <Col xs="7" className="newslink">
              <a href="#21">Tahun Ini, Kamera Mirrorless Canon Bakal Lewati DSLR</a>                   
              </Col>
            </Row>               
          </Col>
        </Row>
      </Container>
      <Footer/>      
      </div>
      );
    }
  }
  class Blog extends Component {
    render() {
        return (
            <div>
              <section id="blog-content" className="noimage">
                <Container>                   
                  <Row>                                                    
                    <Col sm="12">
                      <h2>MacOS Mojave Resmi Sudah Bisa Diunduh di App Store</h2><hr/>
                      <img src={blogCont} className="berita img-thumbnail"/>
                      <p>Pertama kali diperkenalkan pada Juni 2018, kini sistem operasi  
                        <a target='_self' class='inner-link-tag' href='https://indeks.kompas.com/tag/macos'>MacOS</a> &ldquo;
                         <a target='_self' class='inner-link-tag' href='https://indeks.kompas.com/tag/mojave'>Mojave</a>&rdquo; 
                         tersedia resmi untuk publik. Para pengguna MacBook dan iMac bisa mengunduhnya secara gratis melalui Mac 
                         App Store. </p><p>Kendati begitu, ada baiknya belajar dari pengalaman yang sudah-sudah. Setiap kali  
                           <a target='_self' class='inner-link-tag' href='https://indeks.kompas.com/tag/apple'>Apple</a> 
                           merilis sistem operasi baru, ada kecenderungan terjadi masalah semisal performa yang tersendat atau disebut bottleneck.</p><p>
                             Untuk amannya, Anda bisa menunggu hingga beberapa saat sembari menyimak review dari orang-orang yang lebih 
                             dulu memperbarui ke MacOS Mojave. Jika sudah yakin, barulah perbarui MacBook atau iMac Anda. </p><p>MacOS 
                               Mojave tersedia untuk para pengguna iMac dan MacBook keluaran 2012 atau yang lebih baru. Modelnya bisa 
                               apa saja, mulai dari MacBook biasa, MacBook Air, MacBook Pro, Mac Mini, iMac, iMac Pro, dan Mac Pro.</p>
                               <p>Cara mengunduhnya mudah, cukup bertandang ke Mac App Store, lalu cari &ldquo;MacOS Mojave&rdquo;. 
                                 Setelah ketemu, tekan tombol install dan klik &ldquo;Continue&rdquo; untuk melanjutkan proses, 
                                 sebagaimana dihimpun <em>KompasTekno</em>, Selasa (25/9/2018), dari <em>TechRadar</em>.</p>
                                 <p><strong>Fitur-fitur andalan MacOS Mojave</strong></p><p>Salah satu fitur andalan MacOS Mojave 
                                   adalah &ldquo;Dark Mode&rdquo;. Sesuai namanya, mode ini memungkinkan tampilan antarmuka serba gelap 
                                   yang benar-benar berbeda dari sebelumnya.
                      </p><p><strong>Baca juga: <a href="https://tekno.kompas.com/read/2018/04/22/16070047/benarkah-apple-bakal-menggabungkan-macos-dan-ios-" class="inner-link-baca-juga" target="_self">
                      Benarkah Apple Bakal Menggabungkan MacOS dan iOS?</a></strong></p><p>Dark Mode di MacOS Mojave 
                        mencakup jendela-jendela yang terbuka, dock, bahkan juga aplikasi. Tujuannya agar mata 
                        tak mudah lelah terus-terusan berada di depan layar. </p><p>Fitur lainnya adalah &ldquo;Stacks&rdquo; 
                          yang otomatis mengumpulkan dan mengkategorisasikan beragam file. Dengan begitu, tak perlu khawatir 
                          file Anda berceceran dan sulit ditemukan.</p><p>Lalu, di Finder ada tampilan preview bergulir atau disebut &ldquo;Carousel&rdquo;. 
                            Hal ini memudahkan pengguna melihat file gambar, apalagi ada sidebar yang menampilkan informasi metadata dan tombol-tombol perintah. </p><p>Tombol-tombol itu sifatnya 
                          kontekstual dan bisa berganti tergantung apa yang tengah dilakukan pengguna. Saat memilih banyak gambar 
                          sekaligus misalnya, akan muncul tombol untuk menggabungkannya dalam satu file PDF. </p>
                      
sumber, <a target="_blank" href="https://tekno.kompas.com/read/2018/09/25/10442037/macos-mojave-resmi-sudah-bisa-diunduh-di-app-store">kompas.com</a><br/>
Penulis : Fatimah Kartini Bohang<br/>
Editor : Reska K. Nistanto<br/>
                    </Col>
                  </Row>                   
                </Container>
              </section>
            </div>
    );
   }
  }


// WEBPACK FOOTER //
// ./src/blog.js